import {createRouter, createWebHistory} from 'vue-router';
import MonitoringView from '../components/MonitoringView.vue';
import Login from '../components/UserLogin.vue';
import CarriersView from "../components/CarriersView.vue";
import ObjectsView from "../components/ObjectsView.vue";
import UsersView from "../components/UsersView.vue";
import ReportsView from "../components/ReportsView.vue";
import ConfigurationView from "../components/ConfigurationView.vue";
import NotificationView from "@/components/NotificationView.vue";

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/monitoring',
        alias: '/',
        name: 'MonitoringView',
        component: MonitoringView
    },
    {
        path: '/objects',
        name: 'ObjectsView',
        component: ObjectsView
    },
    {
        path: '/users',
        name: 'UsersView',
        component: UsersView
    },
    {
        path: '/reports',
        name: 'ReportsView',
        component: ReportsView
    },
    {
        path: '/carriers',
        name: 'CarriersView',
        component: CarriersView
    },
    {
        path: '/notifications',
        name: 'NotificationView',
        component: NotificationView
    },
    {
        path: '/configuration',
        name: 'ConfigurationView',
        component: ConfigurationView
    },
    // Добавьте другие маршруты здесь
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
